import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import {
  TRouteSchedule,
  TSaveTripResponse,
} from 'features/routing/types/route-schedule';

import { TTransportBookingForm } from '../forms/transport-booking';

export type TTransportBookingState = {
  bookingDetails?: TTransportBookingForm;
  fleets?: TRouteSchedule[];
  selectedRoute?: TRouteSchedule;
  selectedSeats?: number[];
  tripResponse?: TSaveTripResponse;
};

const createTransportBookingSlice = (initialState: TTransportBookingState) =>
  createSlice({
    name: 'transportBooking',
    initialState,
    reducers: {
      setRoutes(state, { payload }: PayloadAction<TRouteSchedule[]>) {
        state.fleets = payload;
      },

      clearBooking(state) {
        delete state.bookingDetails;
        delete state.fleets;
        delete state.selectedRoute;
        delete state.selectedSeats;
        delete state.tripResponse;
      },

      setTripResponse(state, { payload }: PayloadAction<TSaveTripResponse>) {
        state.tripResponse = payload;
      },

      setBookingDetails(
        state,
        { payload }: PayloadAction<TTransportBookingForm>
      ) {
        state.bookingDetails = payload;
      },

      setRoute(state, { payload }: PayloadAction<TRouteSchedule>) {
        state.selectedRoute = payload;
      },

      clearRoute(state) {
        delete state.selectedRoute;
      },

      setSeats(state, { payload }: PayloadAction<number[]>) {
        state.selectedSeats = payload;
      },

      clearSeats(state) {
        delete state.selectedSeats;
      },
    },
  });

const transportBookingSlice = createTransportBookingSlice({});

export const {
  clearBooking,
  setRoutes,
  setBookingDetails,
  setRoute,
  clearRoute,
  clearSeats,
  setSeats,
  setTripResponse,
} = transportBookingSlice.actions;

export default transportBookingSlice.reducer;
